import React, { useState, useEffect } from 'react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import Sidebar from '../../../Components/Sidebar/Sidebar';
import axios from 'axios';

import verificandoToken from '../../../../FuncoesGerais/VerificarToken';
import verificandoApp from '../../../../FuncoesGerais/verificaApp';
import { ensureProtocol } from '../../../../config/backend';

import '../../styles/inventario.css';
import './NovoHardware.css';

function NovoHardware(props) {

    const history = useHistory();

    const location = useLocation();
    const { id } = location.state || {};

    const [data, setData] = useState([]);
    const [selected, setSelected] = useState("");

    const pegarEquipamento = async (e) => {

        let listaEquipamentos = [];

        verificandoToken();

        const token = localStorage.getItem('token');

        try {
            const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/equipamentos/lista", {
                headers: {
                    Authorization: `${token}`
                }
            });
            let i = 0;

            while (i < response.data.length) {

                listaEquipamentos.push({
                    nome: response.data[i].nomeqp,
                    codi: response.data[i].codeqp,
                    desc: response.data[i].deseqp,
                })
                i++;
            }
            setData(listaEquipamentos);

        } catch (error) {
            console.error('Erro ao buscar dados:', error);
        }
    };

    const verificar = async () => {
        const resultado = await verificandoApp("ATENDENTE");

        if (!resultado) {
            history.push("/");
        }
    };

    const [serEqp, setSerEqp] = useState('');
    const [patEqp, setPatEqp] = useState('');
    const [desEqp, setDesEqp] = useState('');
    const [sitEqp, setSitEqp] = useState('');
    const [codHar, setCodHar] = useState('');
    const [codEqp, setCodEqp] = useState('');

    const [obsEqp, setObsEqp] = useState('');

    const [updIns, setUpdIns] = useState('I');
    const [mensagem, setMensagem] = useState('');
    const [sucesso, setSucesso] = useState('N');

    const [placeId, setPlaceId] = useState("Digite sequência do equipamento para edição ou deixe em branco para adicionar");

    const inserindoHistorico = async () => {

        let desHis = "";
        let codigoHardware = codHar;

        if (updIns === 'I') {
            desHis = "Inserido novo hardware: " + serEqp + "\n - " + desEqp + "\nPatrimônio: " + patEqp + "\nSituação: " + sitEqp;

            verificandoToken();
            const token = localStorage.getItem('token');

            try {
                const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/hardware/ultimoNumero", {
                    headers: {
                        Authorization: `${token}`
                    }
                });

                codigoHardware = response.data[0].CODHAR;

            } catch (error) {

            }

        } else {

            if (sitEqp === "A") {
                desHis = "Alterado hardware: " + serEqp + "\n - " + desEqp + "\nPatrimônio: " + patEqp + "\nSituação: " + sitEqp;
            } else {
                desHis = "Alterada Situação do Hardware: " + sitEqp + "\n";
                desHis += obsEqp;
            }

        }

        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            await axios.post(ensureProtocol(localStorage.getItem("ipBackend2")) + "/hishardware",
                { codHar: codigoHardware, desHis },
                {
                    headers: {
                        Authorization: `${token}`
                    }
                });

        } catch (error) {
            setMensagem('Erro ao inserir/atualizar dados');
            setSucesso('N');
        }

    };

    const verificarCampos = async () => {

        if (serEqp.trim() === '') {
            setMensagem("Atenção deve ser inserido a série do equipamento!")
            return;
        }

        if (desEqp.trim() === '') {
            setMensagem("Atenção deve ser inserida uma descrição válida!");
            return;
        }

        if (patEqp.trim() === '') {
            setMensagem("Atenção deve ser inserido o patrimonio do equipamento!");
            return;
        }

        if (sitEqp.trim() === '') {
            setMensagem("Atenção deve ser inserida situação do equipamento!");
            return;
        }

        setMensagem("");
    };

    const buscandoHarware = async (codHar) => {

        verificandoToken();

        if (codHar) {
            try {

                const token = localStorage.getItem('token');

                const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/hardware/espec", {
                    headers: {
                        Authorization: `${token}`
                    },
                    params: {
                        codHar: codHar
                    }
                });

                if (response.data.length > 0) {

                    setUpdIns("U");

                    setCodHar(codHar);
                    setSerEqp(response.data[0].sereqp);
                    setDesEqp(response.data[0].deseqp);
                    setPatEqp(response.data[0].pateqp);
                    setSitEqp(response.data[0].siteqp);
                    setCodEqp(response.data[0].codeqp);

                    setSelected(response.data[0].codeqp);

                } else {

                    setUpdIns("I");

                    setCodHar("");
                    setSerEqp("");
                    setDesEqp("");
                    setPatEqp("");
                    setSitEqp("");
                    setCodEqp("");
                }

            } catch (error) {
                console.error('Erro ao buscar dados:', error);
            }
        }
    };

    useEffect(() => {

        verificar();
        pegarEquipamento();

        if (id) {
            setPlaceId(id);
            setCodHar(id);
            buscandoHarware(id);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const inserindoHardware = async () => {

        if (sitEqp !== 'A' && obsEqp.trim() === '') {
            setMensagem("Atenção deve ser inserida uma observação para a situação do equipamento!");
            return;
        };

        verificarCampos();
        verificandoToken();

        const token = localStorage.getItem('token');

        try {
            if (updIns === 'I') {
                await axios.post(ensureProtocol(localStorage.getItem("ipBackend2")) + "/hardware",
                    { serEqp, patEqp, desEqp, sitEqp, codEqp },
                    {
                        headers: {
                            Authorization: `${token}`
                        }
                    });
            } else {

                if (sitEqp !== 'A') {

                    try {
                        const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/vinculacao/hardware", {
                            headers: {
                                Authorization: `${token}`
                            }, params: {
                                codHar: codHar
                            }
                        });

                        if (response.data.length > 0) {
                            alert('ATENÇÃO REALIZAR DESVINCULO DO EQUIPAMENTO, ANTES DE ALTERAR.');
                            return;
                        }
                    } catch (error) {

                        return;
                    }
                }
                await axios.put(ensureProtocol(localStorage.getItem("ipBackend2")) + "/hardware",
                    { serEqp, patEqp, desEqp, sitEqp, codHar, codEqp },
                    {
                        headers: {
                            Authorization: `${token}`
                        }
                    });

            }
            inserindoHistorico();
            setMensagem('');
            setSucesso('S');
        } catch (error) {
            setMensagem('Erro ao inserir/atualizar dados');
            setSucesso('N');
        }
    };

    const pegarDescricao = async (codEqp) => {

        let codeqp = codEqp;

        setCodEqp(codeqp);

        verificandoToken();

        const token = localStorage.getItem('token');

        try {
            const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/equipamentos/espec", {
                headers: {
                    Authorization: `${token}`
                }, params: {
                    codEqp: codeqp
                }
            });

            setDesEqp(response.data[0].layeqp);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
        }
    };

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
            <div className="container-fluid titulo inventario-page">
            <div className="col-4">
                <h1>{updIns === 'U' ? "Alterar" : "Cadastrar"} Hardware</h1>
            </div>
            <form>
                <div className="form-group mb-1">
                    <label htmlFor="exampleInputEmail1">Identificação Hardware</label>
                    <input type="email" onChange={(e) => buscandoHarware(e.target.value)} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder={placeId} />
                </div>
                <div className="col">
                    <label htmlFor="exampleInputEmail1">Equipamento</label>
                    <select className="form-control disable" value={selected} onChange={(e) => { setSelected(e.target.value); pegarDescricao(e.target.value); }}>
                        <option value="">Selecione...</option>
                        {data.map((opt) => (
                            <option key={opt.codi} value={opt.codi}>
                                {opt.nome}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="form-group mb-1">
                    <label htmlFor="exampleInputEmail1">Série</label>
                    <input type="email" onChange={(e) => setSerEqp(e.target.value)} value={serEqp} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Série do Equipamento " />
                </div>
                <div className="form-group mb-1">
                    <label htmlFor="exampleInputEmail1">Descrição</label>
                    <textarea type="email" className="form-control" rows={20} onChange={(e) => setDesEqp(e.target.value)} value={desEqp} id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Descrição/Layout Equipamento" />
                </div>
                <div className="form-group mb-1">
                    <label htmlFor="exampleInputEmail1">Patrimônio</label>
                    <input type="email" className="form-control" rows={10} onChange={(e) => setPatEqp(e.target.value)} value={patEqp} id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Patrimônio do Equipamento" />
                </div>

                <div className="form-row row mb-1">
                    <div className="form-group col">
                        <label htmlFor="inputEstado">Situação</label>
                        <select id="inputEstado" className="form-control" value={sitEqp} onChange={(e) => { setSitEqp(e.target.value) }}>
                            <option>Escolher...</option>
                            <option value={"A"}>Ativo</option>
                            <option value={"I"}>Inativo</option>
                            <option value={"R"}>Roubado</option>
                            <option value={"Q"}>Quebrado</option>
                        </select>
                    </div>
                </div>

                {sitEqp !== "A" && (
                    <div className="form-group mb-1">
                        <label htmlFor="inputObs">Descrição</label>
                        <textarea type="email" className="form-control" rows={5} onChange={(e) => setObsEqp(e.target.value)} value={obsEqp} id="inputObs" aria-describedby="obs" placeholder="Informe observação..." />
                    </div>
                )}

                <button onClick={inserindoHardware} type="button" className="btn btn-secondary btn-acao mt-4">Salvar</button>
            </form>

            {mensagem.length > 0 ? <div className="alert alert-danger mt-2" role="alert">{mensagem}</div> : null}
            {sucesso === 'S' ? <Redirect to='/home' /> : null}
            </div>
            </main>
        </div>
    );
}

export default NovoHardware;
